// extracted by mini-css-extract-plugin
module.exports = {"investors":"SpeakerCards_investors__xpNdp","btn":"SpeakerCards_btn__2vG2o","card":"SpeakerCards_card__oM0l9"};